<!-- 首页 -->
<template>
  <div class="blankContainer">
    <div class="index-main">
      <div class="topBox">
        <div class="topContent">
          <img class="icon" src="@/assets/loan.png" alt />
        </div>
      </div>
      <div class="bottomBox">
        <span class="title">产品简介</span>
        <div class="textList">
          <p>面向TCL优质供应商伙伴，可用于支取现金，快速满足企业资金周转需求。</p>
          <p>
            1.准入快速：准入手续简单，授信审批快，额度
            <span class="textColor">可循环</span>使用
          </p>
          <p>
            2.操作简单：
            <span class="textColor">1分钟</span>融资操作，
            <span class="textColor">2小时</span>放款到账
          </p>
          <p>
            3.随借随还：单笔最长可借
            <span class="textColor">6个月，</span>按日计算
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  created () {

  },
  mounted () {

  },
  methods: {

  }
}
</script>
<style lang='scss' scoped>
.blankContainer {
  .index-main {
    margin-bottom: -20px;
    padding: 0;
    width: 100%;
    height: 100%;
    .textColor {
      color: #ff9043;
    }
    .topBox {
      display: flex;
      justify-content: space-between;
      background-image: url('../../assets/background.jpg');
      background-size: 100%;
      background-repeat: no-repeat;
      position: relative;
      width: 100%;
      .topContent {
        width: 360%;
        margin-top: 4% auto 0;
        margin-bottom: 7%;
        text-align: center;
        .icon {
          width: 24%;
          margin-top: 6%;
        }
        .imgText {
          display: block;
          font-size: 20px;
          color: #333;
          white-space: nowrap;
        }
      }
    }
    .bottomBox {
      overflow: hidden;
      width: 100%;
      .title {
        display: block;
        font-size: 20px;
        margin-top: 3%;
        text-align: center;
      }
      .textList {
        margin: 2% auto 0;
        font-size: 16px;
        color: #999;
        text-align: left;
        width: 510px;
        white-space: nowrap;
      }
    }
    @media (max-width: 1440px) {
      .imgText {
        font-size: 16px !important;
      }
      .title {
        font-size: 16px !important;
      }
      .textList {
        font-size: 14px !important;
      }
    }
    @media (min-width: 1440px) {
      .imgText {
        font-size: 20px !important;
      }
      .title {
        font-size: 20px !important;
      }
      .textList {
        font-size: 16px !important;
      }
    }
  }
}
</style>
